module.exports = __webpack_public_path__ + "img/RS3621xs+.521d5884.png";